module.exports = __webpack_public_path__ + "img/arrow-up-right-circle.aa5bf87e.svg";